import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label", "fileName"]

  connect() {
    this.updateFileName()
    this.validateFile()
  }

  updateFileName() {
    const input = this.inputTarget
    const fileNameElement = this.hasFileNameTarget ? this.fileNameTarget : null

    if (fileNameElement) {
      if (input.files && input.files.length > 0) {
        const fileName = input.files[0].name
        fileNameElement.textContent = fileName
      } else {
        fileNameElement.textContent = "Ningún archivo seleccionado"
      }
    }
    
    // Trigger validation when file changes
    this.validateFile()
  }

  validateFile() {
    // Check if we have an error element in our parent that needs to be hidden/shown
    const errorElement = this.element.querySelector('[data-file-validation-target="error"]')
    if (errorElement) {
      if (this.inputTarget.files && this.inputTarget.files.length > 0) {
        errorElement.classList.add('hidden')
      } else {
        // Only show error if the form was attempted to be submitted
        if (this.element.closest('form').classList.contains('was-validated')) {
          errorElement.classList.remove('hidden')
        }
      }
    }
  }
}